import { createContext, useContext, useState } from "react";

const StepperContext = createContext();

const StepperProvider = ({ children }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [stepFormData, setStepFormData] = useState({});

  const handleNext = () => setActiveStep((prev) => prev + 1);

  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleToStart = () => setActiveStep((prev) => 0);


  const handleStep = (step) => setActiveStep(step);

  const value = {
    activeStep,
    stepFormData,
    handleNext,
    handleBack,
    handleToStart,
    handleStep,
    setStepFormData,
  };

  return (
    <StepperContext.Provider value={value}>{children}</StepperContext.Provider>
  );
};

export const useStepper = () => useContext(StepperContext);

export default StepperProvider;
